<template>
<div class="form-group" :class="[{ 'coff-input-error' : error }]" :key="uuid">

    <label htmlFor="input">
        <b>{{$t(label)}}</b>
        <slot name="label"></slot>
    </label>

    <div class="input-group">
        <Password v-on="listeners" :value="value" :id="uuid"
            :promptLabel="$t(promptLabel)"
            :weakLabel="$t(weakLabel)"
            :mediumLabel="$t(mediumLabel)"
            :strongLabel="$t(strongLabel)"
            :feedback="feedback"
            :class="[{ 'p-error' : error }]"
        />
        <span v-if="error">{{ $t(errorMessage)}}</span>
    </div>

</div>
</template>

<script>
    import Utils from "@/utils/Utils";

    export default {
        name: "CoffInputPassword",

        props:{
            label: {type: String, default: null},
            value: String,
            error: {type: Boolean, default: false},
            errorMessage: {type: String, default: 'field.default.error'},
            id: null,
            promptLabel: {
                type: String,
                default: 'passwordLabel.promptLabel'
            },
            weakLabel: {
                type: String,
                default: 'passwordLabel.weak'
            },
            mediumLabel: {
                type: String,
                default: 'passwordLabel.medium'
            },
            strongLabel: {
                type: String,
                default: 'passwordLabel.strong'
            },
            feedback: {
                type: Boolean,
                default: true
            }
        },

        data(){
          return {
              uuid: Utils.uuid(),
          }
        },

        mounted() {
            if(this.id){
                this.uuid = this.id;
            }
        },

        computed: {
            listeners() {
                return {
                    ...this.$listeners,
                    Password: event => this.$emit('Password', event.target.value)
                };
            },
        }
    }
</script>

<style scoped>

</style>
